import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  loginSuccess,
  loginFailure,
  logoutFailure,
  forgetPasswordSuccess,
  forgetPasswordFailure,
  resetPasswordSuccess,
  resetPasswordFailure,
  logoutSuccess
} from "../../actions";
import {
  LOGIN,
  LOGOUT,
  FORGET_PASSWORD,
  RESET_PASSWORD,
} from "../../Actions/types";
import api from "../../../helper/api";
import { setCookies } from "../../../helper/constant";

function* fetchLogin(action) {
  try {
    const response = yield api.post("admin/login", action.payload.form);
    if (response?.data?.code === 200) {
      setCookies("token", response?.data?.data?.token);
      setCookies("adminData", JSON.stringify(response?.data?.data?.user));
      yield put(loginSuccess({ data: response?.data?.data }));
      yield call(action?.payload?.callback, response?.data);
      toast.success(response?.data?.message);
    } else if (response?.data?.code !== 200) {
      yield put(loginFailure({ error: response?.data?.message }));
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(loginFailure({ error: e.message }));
  }
}

function* fetchLogout(action) {
  try {
    const response = yield api.post("admin/logout");
    if (response?.data?.code === 200) {
      toast.success(`Logout successfully`);
      yield call(action?.payload?.callback, response?.data);
      yield put(logoutSuccess({ data: true }));
    } else {
      toast.error(response?.data?.message);
      yield call(action?.payload?.callback, response?.data);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(logoutFailure({ error: e }));
  }
}

function* fetchForgetPassword(action) {
  try {
    const response = yield api.post(
      "admin/forgotPassword",
      action.payload.form,
    );
    if (response?.data?.code === 200) {
      setCookies("token", response?.data?.data?.token);
      yield call(action?.payload?.callback, response?.data);
      yield put(forgetPasswordSuccess({ data: response?.data }));
      toast.success(`${response?.data?.message}`);
    } else if (response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(forgetPasswordFailure({ error: e }));
  }
}

function* fetchResetPassword(action) {
  try {
    const response = yield api.put(
      "admin/resetPassword",
      action.payload.form
    );
    if (response?.data?.code === 200) {
      setCookies("token", response?.data?.data?.token);
      yield call(action?.payload?.callback, response?.data);
      yield put(resetPasswordSuccess({ data: response?.data }));
      toast.success(response?.data?.message);
    } else if (response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    yield put(resetPasswordFailure({ error: e }));
  }
}

function* loginWatcher() {
  yield takeLatest(LOGIN, fetchLogin);
}

function* logoutWatcher() {
  yield takeLatest(LOGOUT, fetchLogout);
}

function* forgetPasswordWatcher() {
  yield takeLatest(FORGET_PASSWORD, fetchForgetPassword);
}

function* resetPasswordWatcher() {
  yield takeLatest(RESET_PASSWORD, fetchResetPassword)
}

export default function* authSaga() {
  yield all([loginWatcher(), logoutWatcher(), forgetPasswordWatcher(), resetPasswordWatcher()]);
}
